<div class="wrapper-login">
    <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container-xl my-4 d-flex justify-content-between">
            <div class="section-logo">
                <button class="btn navbar-brand" (click)="goToHome()">
                    <img class="logo" src="https://cdn.estore5s.com/asset/estore-logo-transparent.png" alt="estore-logo">
                </button>
            </div>
        </div>
    </nav>

    <div class="section-login container-xl">
        <div class="row">
            <div class="section-text col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="section-image">
                    <img class="dealer-image" src="../../assets/dealer.png" alt="dealer">
                </div>
                <h1 class="title">
                    Setup your store in
                    <span class="text-yellow">minutes.</span>

                    <img class="yellow-line" src="../../assets/yellow-line.png" alt="line">
                </h1>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card login-card">
                    <h3 class="card-title">Log in with your Dealer Account</h3>
                    <form class="form">
                        <div class="form-group">
                            <label class="form-label">Username</label>
                            <input type="text" class="form-control">
                            <img *ngIf="checkedFullname" class="checkmark" src="../../assets/icon/checkmark_green.png" alt="check">
                        </div>
                        <div class="form-group">
                            <label class="form-label">Password</label>
                            <input type="password" class="form-control">
                            <img *ngIf="checkedPassword" class="checkmark" src="../../assets/icon/checkmark_green.png" alt="check">
                        </div>
                        <button class="btn btn-login">Login</button>
                    </form>
                    <div class="card-info">
                        <p class="card-text">By continuing, you agree to the Terms of Service and Privacy Policy</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer container-fluid py-3">
    <p class="text-center text-white">{{ "eStore " | translate }}&copy; {{ " Copyright "| translate }}  {{ currentYear }}</p>
</div>
